export enum BOLETO_CONST {
  TEST_ID = 'boleto-with-data',
}

export type BoletoProps = {
  deliveryDate: string;
  expirationDate: string;
  paymentMethod: string;
  url?: string;
  value: string;
  trackUserClicks: (event: UIEvent<HTMLButtonElement>) => void;
};
